import { useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';

import { openInNewTab } from '@/helpers';
import { coursesApi, useGetCertificateQuery } from '@/services/course';

import { useLog } from './useLog';

export const useCertificate = (progress: number) => {
  const { hash } = useParams<{ hash: string }>();
  const { activity } = useLog();
  const courseState = coursesApi.endpoints.getCourse.useQueryState(hash);
  const reached = progress >= (courseState.data?.progress_percent ?? 0) && courseState.data?.has_certificate;
  const certificate = useGetCertificateQuery(hash, {
    skip: !reached || !(reached && !courseState.data?.certificate_url)
  });
  const retryRef = useRef(0);
  useEffect(() => {
    if (!courseState.data?.certificate_url && retryRef.current < 5) {
      const timeout = setTimeout(() => {
        certificate.refetch();
        clearTimeout(timeout);
        retryRef.current++;
      }, 5000);
    }
  }, [courseState.data?.certificate_url, certificate]);

  return {
    pending: reached && !courseState.data?.certificate_url,
    reached: reached && courseState.data?.certificate_url,
    url: courseState.data?.certificate_url,
    onClick() {
      openInNewTab(courseState.data?.certificate_url);
      activity('viewCertificate', {
        message: `Visualizou o certificado do curso ${courseState.data?.title}`,
        course_hash: hash
      });
    }
  };
};
